import StudentSurveyDetails from "./StudentSurveyDetails";

export default StudentSurveyDetails